import React from "react";

const CorporateLoadingBlock = () => {
  return (
    <div className="w-[20%] h-[188px] bg-gradient-to-r from-[#F2F2F2] to-[rgba(242, 242, 242, 0.00)] rounded-lg "></div>
  );
};

export default CorporateLoadingBlock;
